import { formatNgn, getProductDiscountPercent } from "../libs/productPricing";
import "./ProductCard.css";

const ProductPriceDisplay = ({
  product,
  size = "card",
  showOffBadge,
  className = "",
}) => {
  const price = product?.price;
  const compareAt = product?.compareAtPrice;
  const discount = getProductDiscountPercent(product);
  const onSale = discount != null;
  const showOffPill = showOffBadge ?? size === "pdp";

  if (price == null) return null;

  return (
    <div
      className={`product-price-display product-price-display--${size}${className ? ` ${className}` : ""}`}
    >
      {onSale && (
        <span className="product-price-display__slash">{formatNgn(compareAt)}</span>
      )}
      <span className="product-price-display__current">{formatNgn(price)}</span>
      {onSale && showOffPill && (
        <span className="product-price-display__off">{discount}% off</span>
      )}
    </div>
  );
};

export const ProductDiscountBadge = ({ product, className = "" }) => {
  const discount = getProductDiscountPercent(product);
  if (discount == null) return null;
  return (
    <span className={`product-card-modern__discount${className ? ` ${className}` : ""}`}>
      -{discount}%
    </span>
  );
};

export default ProductPriceDisplay;
